import styled from "styled-components";

const StyledMenuCategory = styled.section`
    width: 100%;
    height: auto;
    min-height: 90px;

    
    & .apps_wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 10px;
        flex-wrap: wrap;
        list-style: none;
    }
`

export default StyledMenuCategory;